import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { KYMW7005Model } from './kymw7005.model';
import { ActivatedRoute, Router } from '@angular/router';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { GetFeatureListService } from './api-services/get-feature-list.service';
import { GetFeatureGoodsService } from './api-services/get-feature-goods.service';
import { UpdateFeatureGoodsListService } from './api-services/update-feature-goods-list.service';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { FlexGrid, CellRangeEventArgs } from '@grapecity/wijmo.grid';
import { FlexGridFilter } from '@grapecity/wijmo.grid.filter';
import { FeatureGoods } from './vo/feature-goods.model';
import { EventArgs } from '@grapecity/wijmo';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';

@Component({
  selector: 'app-kymw7005',
  templateUrl: './kymw7005.component.html',
  styleUrls: ['./kymw7005.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW7005Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  model: KYMW7005Model = new KYMW7005Model();

  @ViewChild('dtg_FeatureGoods', { static: true }) dtg_FeatureGoods: FlexGrid;
  @ViewChild('flr_FeatureGoods', { static: true }) flr_FeatureGoods: FlexGridFilter;

  // 選択した行インデックス
  private dragIndex: number;

  // クエリパラメータのバリデーション
  private validationsFeatureListRequestParams: {
    invalid: (m: KYMW7005Model) => boolean;
    code: string;
    messages: string[];
  }[] = [
    // 必須チェック
    {
      invalid: m => PlessViewUtilsSub.isEmpty(m.queryParams.orderCode),
      code: 'W0001',
      messages: ['受注コード'],
    },
    // 必須チェック
    {
      invalid: m => PlessViewUtilsSub.isEmpty(m.queryParams.mediumType),
      code: 'W0001',
      messages: ['媒体区分'],
    },
    // 数字文字列チェック
    {
      invalid: m => this.isNaNString(m.queryParams.mediumType),
      code: 'W0004',
      messages: ['媒体区分'],
    },
    // 半角チェック
    {
      invalid: m => !/^[\x20-\x7e]*$/.test(m.queryParams.mediumType),
      code: 'W0004',
      messages: ['媒体区分'],
    },
  ];

  // アップデート用のバリデーション
  private validationsupdateFeatureGoodsListParams: {
    invalid: (m: KYMW7005Model["updateFeatureGoodsList"] ) => boolean;
    code: string;
    messages: string[];
  }[] = [
    // 必須チェック
    {
      invalid: m => m.some(_ => _.OrderCode === ''),
      code: 'W0001',
      messages: ['受注コード'],
    },
    // 必須チェック
    {
      invalid: m => m.some(_ => _.MediumType === ''),
      code: 'W0001',
      messages: ['媒体区分'],
    },
    // 数字文字列チェック
    {
      invalid: m => m.some(_ => this.isNaNString(_.MediumType)),
      code: 'W0004',
      messages: ['媒体区分'],
    },
    // 半角チェック
    {
      invalid: m => m.some(_ => /[^\x20-\x7e]/.test(_.MediumType)),
      code: 'W0004',
      messages: ['媒体区分'],
    },
    // 必須チェック
    {
      invalid: m => m.some(_ => _.OldFeatureCode === ''),
      code: 'W0001',
      messages: ['旧特集コード'],
    },
    // 必須チェック
    {
      invalid: m => m.some(_ => _.NewFeatureCode === ''),
      code: 'W0001',
      messages: ['新特集コード'],
    },
    // 必須チェック
    {
      invalid: m => m.some(_ => _.PCode === ''),
      code: 'W0001',
      messages: ['Pコード'],
    },
    // 必須チェック
    {
      invalid: m => m.some(_ => _.ItemCode === ''),
      code: 'W0001',
      messages: ['アイテムコード'],
    },
    // 必須チェック
    {
      invalid: m => m.some(_ => _.SelectorType === null || _.SelectorType === undefined),
      code: 'W0001',
      messages: ['選定担当区分'],
    },
    // 整数チェック
    {
      invalid: m => m.some(_ => Number.isInteger(_.SelectorType)),
      code: 'W0011',
      messages: ['選定担当区分'],
    },
  ];

  /**
   * Creates an instance of KYMW7004Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetFeatureListService} getFeatureListService
   * @param {GetFeatureGoodsService} getFeatureGoodsService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW7006Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getFeatureListService: GetFeatureListService,
    private getFeatureGoodsService: GetFeatureGoodsService,
    private updateFeatureGoodsListService: UpdateFeatureGoodsListService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private router: Router,
    private getCodeListService: GetCodeListService,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW7004Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW7005';
    // 特集一覧取得処理を呼び出し、取得した情報を画面に反映する。
    this.route.queryParams.subscribe((params) => {
      this.model.queryParams = params;
    });

    // バリデーション
    const invalidItem = this.validationsFeatureListRequestParams.find(_ => _.invalid(this.model));
    if (invalidItem) {
      this.dialogService.openAlertGetMessage(
        invalidItem.code,
        invalidItem.messages
      );
      return;
    }

    // バリデーションで問題ない場合、特集一覧情報のサービスクラスを呼出
    this.getFeatureListService.execute(this.model);
 
    this.getFeatureGoods();   

    // 発注単位区分を取得
    this.getCodeListService.execute('ct026', '', this.model, 'orderUnitTypeListSearchData', null, null, null);
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW7004Component
   */
  public ngAfterViewInit(): void {
    this.dtg_FeatureGoods.itemsSourceChanged.addHandler(
      (_g: FlexGrid, _e: EventArgs) => {
        _g.select(-1, -1);
      }
    );
  }

  /**
   * 付替対象商品一覧取得処理
   *
   */
  getFeatureGoods(f?: () => void) {
    // 付替対象商品一覧取得呼出
    this.getFeatureGoodsService.execute(this.model, () => {
      // 先頭ページ以外を表示時戻るボタンを活性
      this.model.btnBackEnabled = (this.model.pageNo > 1) ? true : false;
      // 最終ページ以外を表示時に次へボタンを活性
      this.model.btnNextEnabled = (this.model.totalNum > this.model.endDispNum) ? true : false;

      // 取得した付替対象商品一覧情報の先頭データの付替ステータスが「2:付替え済み」の場合
      if (this.model.featureGoods[0].ReplacementStatus === '2') {
        // 企画回の<h1>タグ部分の表示内容変更
        this.model.isDisplayTitle = 2;
      } else {
        // 企画回の<h1>タグ部分の表示内容変更
        this.model.isDisplayTitle = 1;
      }

      // 取得した付替対象商品一覧情報のデータの中に、付替ステータスが「2:付替え済み」以外のデータがある場合
      for (const featureGoods of this.model.featureGoodsEdit) {
        if (featureGoods.ReplacementStatus !== '2') {
          // 保存ボタン活性
          this.model.isButtonsDisabled = false;
          break;
        } else {
          // 保存ボタン非活性
          this.model.isButtonsDisabled = true;
        }
      }

      // 明示的に設定
      this.dtg_FeatureGoods.itemsSource = this.model.featureGoodsEdit;

      // コールバックを実行
      if(f) {
        f();
      }
    });
  }

  // labelを取得
  getOrderUnitTypeLabel(value: any): string {
      const found = this.model.orderUnitTypeListSearchData.find(x => x.CodeValue === value);
      return found ? found.CodeName : '';
  }

  /**
   * 数値でないかどうかを判定する(String版)
   * [戻り値]true：数値ではない／false：数値
   *
   * @param value 判定する文字列
   */
  isNaNString(value: string): boolean {
    const number = Number(value);
    return isNaN(number);
  }

  /**
   * 前へをクリックした時に呼び出されるメソッド
   *
   * @memberof KYMW7005Component
   */
  eventBackHandler(): void {
    // 現在のページ番号-1を設定
    this.model.pageNo = (this.model.pageNo <= 1) ? 1 : this.model.pageNo - 1;
    // 前のページのデータをapi呼び出して取得
    this.getFeatureGoods(() => this.changeupdateFeatureGoodsList());
  }

  /**
   * 次へをクリックした時に呼び出されるメソッド
   *
   * @memberof KYMW7005Component
   */
  eventNextHandler(): void {
    // 現在のページ番号+1を設定
    this.model.pageNo = (this.model.pageNo < 1) ? 1 : this.model.pageNo + 1;
    // 次のページのデータをapi呼び出して取得
    this.getFeatureGoods(() => this.changeupdateFeatureGoodsList());
  }

  /**
   * 特集の表示内容取得
   *
   */
  getFeatureName(code: string) {
    const feature = this.model.featureList.find(_ => _.FeatureCode === code);
    return feature ? feature.FeatureCode + ":" + feature.FeatureName : '';
  }

  /**
   * ページャー操作後の変更内容設定
   *
   */
  changeupdateFeatureGoodsList() {
    this.model.featureGoodsEdit = this.model.featureGoodsEdit.map(f => {
      const matchData = this.model.updateFeatureGoodsList.find(s =>
        s.PCode === f.PCode && s.ItemCode === f.ItemCode
      )

     // 該当データがある場合、特集コードとバイヤー向け連絡事項に変更後データを設定
      if (matchData) {
        f.FeatureCode = matchData.NewFeatureCode;
        f.BuyerNotice = matchData.NewBuyerNotice;
      }

      return f;
    });
  }

  /**
   * 更新処理
   *
   */
  update() {
    // 差分がないときは前の画面(特集商品提案状況確認)に遷移
    if (this.model.updateFeatureGoodsList.length === 0) {
      this.router.navigate(['/kymw/7004']);
      return;
    }

    // 確認ダイアログ表示
    this.dialogService.openAlertGetMessage('Q0166', [], _s => {
      if (_s === PlessAlert.Yes) {
        this.model.updateFeatureGoodsList = this.model.updateFeatureGoodsList.filter(f => 
          f.OldFeatureCode === undefined || !(f.OldFeatureCode === f.NewFeatureCode && f.OldBuyerNotice === f.NewBuyerNotice)
        );

        // バリデーション
        const invalidItem = this.validationsupdateFeatureGoodsListParams.find(_ => _.invalid(this.model.updateFeatureGoodsList));
        if (invalidItem) {
          this.dialogService.openAlertGetMessage(
            invalidItem.code,
            invalidItem.messages
          );
          return;
        }

        // 付替対象商品更新処理呼出
        this.updateFeatureGoodsListService.execute(this.model, () => {
          // 更新完了後、前の画面に遷移
          this.router.navigate(['/kymw/7004']);
        });
      }
    });
  }

  /**
   * 変更時処理（付替モード時のみ)
   */
  modify(item: FeatureGoods) {
    //変更されたFeatureCodeと連動しているFeatureNameに更新
    const changeName = { ...this.model.featureList.find(f => f.FeatureCode === item.FeatureCode)};
    if (changeName) {
      item.FeatureName = changeName.FeatureName;
    }

    // 元データからデータ取得
    const originItem = this.model.featureGoods.find(original => 
      original.PCode === item.PCode && original.ItemCode === item.ItemCode
    );

    // 変更内容リストに対象がいるかチェック
    const targetData = this.model.updateFeatureGoodsList.find(
      s => s.PCode === item.PCode && s.ItemCode === item.ItemCode
    );

    if (targetData) {
      // 変更内容リストにあるデータの場合、更新
      targetData.NewFeatureCode = item.FeatureCode;
      targetData.NewBuyerNotice = item.BuyerNotice;
    } else {
      // 変更内容リストにないデータの場合、登録
      this.model.updateFeatureGoodsList.push({
        OrderCode: originItem.OrderCode,
        MediumType: originItem.MediumType,
        OldFeatureCode: originItem.FeatureCode,
        NewFeatureCode: item.FeatureCode,
        PCode: originItem.PCode,
        ItemCode: originItem.ItemCode,
        OldBuyerNotice: originItem.BuyerNotice,
        NewBuyerNotice: item.BuyerNotice,
        SelectorType: originItem.SelectorType,
      });
    }
  }
}
